(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["insta-reels"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    (root || document).querySelectorAll('[data-reels]').forEach(function (sec) {
      if (sec.dataset.reelsReady) return;
      sec.dataset.reelsReady = '1';
      var row = sec.querySelector('[data-reels-row]');
      var prev = sec.querySelector('[data-reels-prev]');
      var next = sec.querySelector('[data-reels-next]');

      // tap wakes one embed (its iframe then takes touches, so Instagram's play
      // works); scrolling the row puts it back to sleep - see the CSS above
      row.addEventListener('click', function (e) {
        var card = e.target.closest('.reel');
        if (!card || card.classList.contains('is-live') || !card.querySelector('.reel__embed')) return;
        if (!e.target.closest('.reel__media') || e.target.closest('a')) return;
        row.querySelectorAll('.reel.is-live').forEach(function (c) { c.classList.remove('is-live'); });
        card.classList.add('is-live');
      });
      row.addEventListener('scroll', function () {
        row.querySelectorAll('.reel.is-live').forEach(function (c) { c.classList.remove('is-live'); });
      }, { passive: true });

      // Play a reel only while it is mostly on screen, so a row of videos costs
      // one or two decoders, not all of them.
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) {
            v.muted = true;
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.6 });
      sec.querySelectorAll('video').forEach(function (v) { io.observe(v); });

      // Linked reels: Instagram's embed posts {type:'MEASURE', height} to us.
      // Its layout is a 54px header, the video box, then a 154px footer, so the
      // height gives the video box; zoom the frame so the video covers the card
      // (object-fit: cover, done by hand) whatever shape the reel is.
      var HEAD = 54, FOOT = 154;
      var embeds = [].slice.call(sec.querySelectorAll('.reel__embed'));
      function fit(f) {
        if (!f._ratio) return;                     // until measured, the CSS default (9:16 reel) holds
        var card = f.parentNode, cw = card.clientWidth, ch = card.clientHeight;
        var vh = f._ratio * cw;                    // box height scales with the frame width
        var wa = cw, ha = vh;
        if (f._ratio >= 1.249) { ha = vh; wa = vh * 9 / 16; }   // tall reels sit pillarboxed in a 4:5 box
        var sc = Math.max(cw / wa, ch / ha);
        var tx = cw / 2 - sc * cw / 2, ty = ch / 2 - sc * (HEAD + vh / 2);
        f.style.height = (HEAD + vh + FOOT) + 'px';
        f.style.transformOrigin = '0 0';
        f.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + sc + ')';
      }
      if (embeds.length) {
        window.addEventListener('message', function (e) {
          if (!/(^|\.)instagram\.com$/.test((e.origin || '').replace(/^https?:\/\//, ''))) return;
          var d; try { d = typeof e.data === 'string' ? JSON.parse(e.data) : e.data; } catch (err) { return; }
          if (!d || d.type !== 'MEASURE' || !d.details || !d.details.height) return;
          embeds.forEach(function (f) {
            if (f.contentWindow !== e.source) return;
            var w = f.offsetWidth;                 // unscaled frame width
            f._ratio = Math.max(0.3, (d.details.height - HEAD - FOOT) / w);
            fit(f);
          });
        });
        window.addEventListener('resize', function () { embeds.forEach(fit); });
      }

      function arrows() {
        var max = row.scrollWidth - row.clientWidth - 2;
        prev.hidden = row.scrollLeft <= 2;
        next.hidden = row.scrollLeft >= max;
      }
      function step(dir) {
        var card = row.querySelector('.reel');
        var w = card ? card.getBoundingClientRect().width + 20 : row.clientWidth / 2;
        row.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
      }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      row.addEventListener('scroll', arrows, { passive: true });
      window.addEventListener('resize', arrows);
      arrows();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-scene"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    (root || document).querySelectorAll('[data-scene]').forEach(function (sec) {
      if (sec.dataset.sceneReady) return;
      sec.dataset.sceneReady = '1';
      // tap a dot to open its card, tap it again (or anywhere else) to close
      sec.addEventListener('click', function (e) {
        var dot = e.target.closest('[data-pin-dot]');
        sec.querySelectorAll('[data-pin]').forEach(function (s) {
          var open = !!dot && s.contains(dot) && !s.classList.contains('is-open');
          s.classList.toggle('is-open', open);
          s.querySelector('[data-pin-dot]').setAttribute('aria-expanded', open);
        });
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-timeline"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    (root || document).querySelectorAll('[data-stl]').forEach(function (sec) {
      if (sec.dataset.stlReady) return;
      sec.dataset.stlReady = '1';
      var track = sec.querySelector('[data-stl-track]');
      var rows = [].slice.call(sec.querySelectorAll('[data-stl-row]'));
      var ticking = false, visible = false;

      function update() {
        ticking = false;
        var vh = window.innerHeight, mark = vh * 0.55;
        var t = track.getBoundingClientRect();
        var p = reduce ? 1 : Math.min(1, Math.max(0, (mark - t.top) / t.height));
        track.style.setProperty('--stl-p', p.toFixed(4));

        var current = -1;
        rows.forEach(function (r, i) {
          var dot = r.querySelector('.stl__dot').getBoundingClientRect();
          var lit = dot.top + dot.height / 2 <= mark;
          r.classList.toggle('is-lit', lit);
          if (lit) current = i;
        });
        rows.forEach(function (r, i) { r.classList.toggle('is-current', i === current); });
      }

      function onScroll() {
        if (visible && !ticking) { ticking = true; requestAnimationFrame(update); }
      }

      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) onScroll();
      }, { rootMargin: '200px 0px' }).observe(sec);

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
